import React from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { ClaimsSVG } from '../../../img/GlobalSVG';
import useDropdown from './useDropdown';
import 'react-toastify/dist/ReactToastify.css';
import { EMAIL } from '../../../../../src/constants/index';
import {
  DefaultPDFEmailBody,
  DefaultCSVEmailBody,
} from '../../../configuration/EmailData';
import ToastMessage from '../ToastMessage';

import './downloadDropdown.scss';

const DownloadDropdown = ({
  data = [],
  label = 'Download',
  showCSV = true,
  showPDF = true,
  openPDF = false,
  fileName = 'dataReport',
  sendEmail = false,
  userEmail = EMAIL.USER_EMAIL,
  userName = 'Javelina Administrator',
  tableHeader = [],
  emailPDFBody = DefaultPDFEmailBody,
  emailCSVBody = DefaultCSVEmailBody,
  successMessage = '',
  errorMessage = '',
  addressCC = EMAIL.ADDRESS_CC,
  addressBCC = EMAIL.ADDRESS_BCC,
  fromAddress = '',
}) => {
  const { t } = useTranslation();
  const { downloadPDF, sendPDF, sendCSV, CSVtableHeader, tableHeaderError } =
    useDropdown({
      data,
      openPDF,
      tableHeader,
      fileName,
      sendEmail,
      userEmail,
      userName,
      emailPDFBody,
      emailCSVBody,
      addressCC,
      addressBCC,
      fromAddress,
    });

  const ErrorMessage = () => {
    return (
      <ToastMessage
        type="error"
        title={t('request_unsuccessful')}
        subTitle={errorMessage}
      />
    );
  };

  const SuccessMessage = () => {
    return (
      <ToastMessage
        type="success"
        title={t('request_successful')}
        subTitle={successMessage}
      />
    );
  };

  const handleSendPDF = () => {
    sendPDF()
      .then(() => {
        toast.success(<SuccessMessage />);
      })
      .catch(() => {
        toast.error(<ErrorMessage />);
      });
  };
  const handleSendCSV = () => {
    sendCSV()
      .then(() => {
        toast.success(<SuccessMessage />);
      })
      .catch(() => {
        toast.error(<ErrorMessage />);
      });
  };

  return (
    <div className="dropdown-container download-dropdown-container">
      <Nav>
        <NavDropdown
          title={
            <div className="pull-left" id="claims-dropdown-menu">
              {sendEmail ? (
                <ClaimsSVG.ClaimSendEmailSVG />
              ) : (
                <ClaimsSVG.ClaimsDownloadSVG />
              )}
              &nbsp;{label}
              <i className="fa fa-angle-down ml-2"></i>
            </div>
          }
        >
          {showCSV && sendEmail ? (
            <NavDropdown.Item onClick={handleSendCSV}>
              {t('send_csv')}
            </NavDropdown.Item>
          ) : (
            <CSVLink
              className="dropdown-item"
              data={data}
              headers={tableHeaderError ? null : CSVtableHeader}
              filename={`${fileName}.csv`}
              directory="Downloads"
            >
              {t('download_csv')}
            </CSVLink>
          )}

          {showPDF && (
            <NavDropdown.Item onClick={sendEmail ? handleSendPDF : downloadPDF}>
              {sendEmail ? 'Send as PDF' : 'Download as PDF'}
            </NavDropdown.Item>
          )}
        </NavDropdown>
      </Nav>
    </div>
  );
};

export default DownloadDropdown;
